<div class="modal-content">
  <div class="modal-body">
    <div class="fc_modal_body">
      <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="modal.dismissAll()"></button>

      <form class="fc_form" [formGroup]="form">
        @if (!showEmail) {
          <div class="secure_share_link">
            <!-- Link Expiration -->
            <div class="link_expiration">
              <h4 class="h4 mb-2">
                Link Expiration <span class="required">*</span>
              </h4>
              <div class="row mb-3">
                <div class="col">
                  <div class="form-check fc_radio d-block">
                    <input type="radio" class="form-check-input" formControlName="NeverExpires"
                      id="expire_on" [value]="false" />
                      <label class="form-check-label" for="expire_on">Expire On</label>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-check fc_radio d-block">
                      <input type="radio" class="form-check-input" formControlName="NeverExpires"
                        id="never_expire" [value]="true" />
                        <label class="form-check-label" for="never_expire">Never Expires</label>
                      </div>
                    </div>
                  </div>
                  @if (!form.value.NeverExpires) {
                    <div class="secure-link-ready">
                      <div class="input-group email-max-width">
                        <input class="form-control mb-0" placeholder="MM-DD-YYYY" name="dp"
                          [required]="!form.value.NeverExpires" formControlName="ExpiryDate" ngbDatepicker
                          #d="ngbDatepicker" readonly />
                          <div class="input-group-append">
                            <button class="input-group-text calendar" (click)="d.toggle()" type="button"
                              aria-label="Calendar">
                              <img src="/assets/images/calendar-gray.svg" alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    }
                    @if (otherIndividualsForm?.email) {
                      <div class="row">
                        <div class="col">
                          <div class="form-group mb-3">
                            <label class="form-label" for="secureMsg">Message (optional)</label>
                            <textarea class="form-control" formControlName="message" id="secureMsg"
                            placeholder="Add a message"></textarea>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <!-- Allow Visibility -->
                  <div class="allow_visibility">
                    <h4 class="h4 mb-2">
                      Allow Visibility <span class="required">*</span>
                    </h4>
                    <p class="mb-2">
                      Visibility allows you to restrict the number of times the
                      recipient can view this link.
                    </p>
                    <div class="row mb-3">
                      <div class="col">
                        <div class="form-check fc_radio d-block">
                          <input type="radio" class="form-check-input" formControlName="AllowedAccessCount"
                            id="allowonce" value="1" />
                            <label class="form-check-label" for="allowonce">Once</label>
                          </div>
                        </div>
                        <div class="col">
                          <div class="form-check fc_radio d-block">
                            <input type="radio" class="form-check-input" formControlName="AllowedAccessCount"
                              id="allowmultiple" value="2" />
                              <label class="form-check-label" for="allowmultiple">Multiple</label>
                            </div>
                          </div>
                        </div>
                        @if (form.value.AllowedAccessCount != 1) {
                          <div class="input-group email-max-width"
                            style="margin-top: 25px">
                            <input class="form-control" formControlName="AllowedAccessCount"
                              (keypress)="allowOnlyNumbers($event)" />
                            </div>
                          }
                        </div>
                        <div class="secure_link">
                          <div class="form-group">
                            <label class="form-label" for="secure_link">Your Secure Link</label>
                            <div class="input-group">
                              <input class="form-control" formControlName="secureLink" />
                              <button type="button" class="input-group-text primary_btn"
                                (click)="otherIndividualsForm?.email ? sharelink() : (showEmail = true)">
                                Share Link
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    <!-- Secure link second popup -->
                    @if (showEmail) {
                      <div class="secure-link-ready secure-link-second">
                        <div class="secure-link-option">
                          <h4 class="text-center">
                            {{ user.userInfo?.family?.name }} family
                          </h4>
                          <div class="form-group">
                            <label class="form-label"><span class="required">*</span>Email shared link</label>
                            <input type="email" id="sharerEmail" class="form-control bottom-25" maxlength="50"
                              formControlName="email" placeholder="Email Address" required />
                              @if (form.get('email').hasError('pattern') && form.get('email').touched) {
                                <div
                                  class="text-danger">
                                  Please enter a valid email.
                                </div>
                              }
                            </div>
                          </div>
                          <div class="form-group d-flex justify-content-between align-items-center">
                            <button type="button" class="border_btn" (click)="modal.dismissAll()">
                              Cancel
                            </button>
                            <button type="button" disableDuringAjax class="primary_btn" (click)="sharelink()">
                              Send
                            </button>
                          </div>
                        </div>
                      }
                    </form>
                  </div>
                </div>
              </div>